import 'core-js/modules/es.string.trim.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.split.js';

class CreditCardHolder {
  constructor(value) {
    this.value = value;
  }
  static build(value) {
    return new CreditCardHolder(value.trim());
  }
  isValid() {
    return this.value.split(' ').filter(n => n.trim().length).length > 1;
  }
  getValue() {
    return this.value;
  }
}

export { CreditCardHolder };
